import React from 'react';
import {
  LogoImage,
  FormBox,
  TitleSection,
  ResetContainer,
  ResetTitle,
  ResetWraper,
  ResetPhrase,
  LogoWrapper,
  EmailImage,
  ImageContainer
} from './styles';
import logoImage from '../../../assets/soji_logo.svg';
import mailImage from '../../../assets/email_image.svg';

const CheckEmail = () => {
  return (
    <>
      <ResetWraper>
        <LogoWrapper>
          <LogoImage src={logoImage} alt="logo" />
        </LogoWrapper>
        <ResetContainer>
          <FormBox>
            <TitleSection>
              <ResetTitle>Check your email</ResetTitle>
            </TitleSection>
            <ResetPhrase>
              Check your email linked to your account, a code has been sent to
              recover your password
            </ResetPhrase>
            <ImageContainer>
              <EmailImage src={mailImage} />
            </ImageContainer>
          </FormBox>
        </ResetContainer>
      </ResetWraper>
    </>
  );
};

export default CheckEmail;
